@if (user) {
  <div id="hero">
    <img [src]="img" alt="User image"/>
    <div class="text">
      <h2>
        {{ user.s_first_name
        }}{{ user.s_second_name ? " " + user.s_second_name : "" }}
        {{ user.s_last_name }}
      </h2>
      @for (hs of userHSs; track hs) {
        <div class="info">
          <ion-icon name="library-outline"></ion-icon>
          <div>
            <p id="hs">{{ hs.institution.s_name }}</p>
            <p id="grade">{{ hs.c_grade_level }}<sup>th</sup> grade senior</p>
          </div>
        </div>
      }
    </div>
  </div>
}
